angular
  .module('UserExamControllers')

  .filter('supportSix', function() {
    return function(input, index) {
      // Todo performance
      if (index == 'end') {
        input = input.replace(/[\s\S]*##/g, '');
        return input.replace(/[\n\r]/g, '<br>');
      } else {
        var re = /[\s\S]*?##/g;
        var t = input.match(re);
        if (t) {
          input = t[index].replace(/##/g, '');
        }
        return input.replace(/[\n\r]/g, '<br>');
      }
    };
  })

  .filter('showFirstAnswer', function() {
    return function(input) {
      if (input.includes('/')) {
        return _.first(input.split('/'));
      }
      return input;
    };
  })

  .filter('showLastAnswer', function() {
    return function(input) {
      if (input.includes('/')) {
        let gd = _.last(input.split('/'));
        return gd;
      }
      return input;
    };
  })

  .filter('conjugArray', function() {
    function getInsideDisplay(row) {
      let pronomsArrays = "je,tu,il,elle,on,nous,vous,ils,elles,qu'il,qu'elle,qu'on,qu'ils,qu'elles,que vous,que nous"
        .split(',')
        .map(r => r + ' ');
      let verbe = row;
      let pronom = null;
      // return `<span class="pronom">${pronom}</span><span class="verbe">${verbe}</span>`;
      return `<span>${verbe}</span>`;
    }
    return function(input) {
      let rows = input.split('|');
      return `<ul class="conjugArray">${rows
        .map(row => {
          return `<li>${getInsideDisplay(row)}</li>`;
        })
        .join('')}</ul>`;
    };
  })

  .filter('fillBlankInput', function() {
    return function(input, autoSubmit = true, goodAnswer = null) {
      let eventKeyCode = autoSubmit ? 13 : null;
      let width = 160;
      if (goodAnswer && goodAnswer.text) {
        width = goodAnswer.text.length * 8;
      }
      width = _.max([width, 160]);

      return input.replace(
        /##/g,
        `<input ng-keyup="training && $event.keyCode == ${eventKeyCode} && checkFinished(true)" class="custom-input" ng-if="!finished" spellcheck="false" autocomplete="off" ng-disabled="finished" ng-model="userAnswersInput[question.id]" ng-blur="exam && question.choice_user ? saveAnswer(question.choice_user, support, userAnswersInput[question.id]) : null" ng-change="checkedOpenGapAnswer(question, userAnswersInput[question.id])" placeholder="" style="width: ${width}px">
      <div ng-if="finished" class="custom-input" style="display: inline-block;width: ${width}px;max-width: calc(100% - 32px);">
      <span ng-if="!finished || (finished && (choice.is_correct || question.choice_user === choice.id))" ng-repeat="choice in question.choices | reverse">
        <span ng-if="choice.is_correct" class="text-success">

          <span ng-if="question.choice_user === choice.id">
            {{userAnswersInput[question.id]}}
          </span>
          <span ng-if="question.choice_user !== choice.id">
            {{(choice.text | showLastAnswer)}}
          </span>

        </span>
        <span style="margin-right: 12px; text-decoration: line-through;" class="text-fail" ng-if="support.has_correction && choice.is_correct === false && userAnswersInput[question.id]">
          {{choice.extra_value || userAnswersInput[question.id]}}
        </span>
        <span ng-if="!support.has_correction && choice.is_correct === false && userAnswersInput[question.id]">
          {{choice.extra_value || userAnswersInput[question.id]}}<br> <span style="opacity: 0.6">Exemple de réponse :</span><br>
        </span>
      </span>
    </div>
      `
      );
    };
  })

  .filter('reverse', function() {
    return function(items) {
      return items.slice().reverse(); // Create a copy of the array and reverse the order of the items
    };
  })

  .filter('blank', function() {
    return function(input) {
      return input.replace(/##/g, '____________');
    };
  })

  .filter('score', [
    'EXAM',
    function(EXAM) {
      return function(input) {
        if (!input) {
          return input;
        }
        if (EXAM === 'bright') {
          if (!input) {
            input = '0';
          }
          var inputString = input.toString();
          if (!inputString.includes('.')) {
            return inputString + '.0';
          }
        }
        if (EXAM === 'linguaskill') {
          let inputString = parseInt(input, 10);
          if (inputString > 180) {
            return '180+';
          }
          return Math.trunc(inputString);
        }
        return input;
      };
    }
  ])

  .filter('partToString', [
    'exam',
    function(exam) {
      return function(part) {
        console.log('partToString');
        if (part) {
          return exam.partGetTitle(part);
        } else {
          return '';
        }
      };
    }
  ])

  .filter('partHelpToString', [
    'exam',
    function(exam) {
      return function(part) {
        return exam.getPartById(part).directionHTML;
      };
    }
  ])

  .filter('toAlphabet', function() {
    return function(item) {
      var convert = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
      return convert[item];
    };
  })

  .filter('customFilter', function() {
    return function(input, src, attribute) {
      if (src) {
        var t = [];

        for (var i = 0; i < input.length; i++) {
          if (
            input[i][attribute].toLowerCase().indexOf(src.toLowerCase()) > -1
          ) {
            t.push(input[i]);
          }
        }

        return t;
      } else {
        return input;
      }
    };
  })

  .filter('md', function() {
    return function(input) {
      return input;
    };
  });
